module.exports = flarum.core.compat['components/Select'];